import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Folder.svg",
  "use": "Folder.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Folder.svg\"><path d=\"M56.0115,28.1742,54.388,49.2509a3.0024,3.0024,0,0,1-2.9951,2.77H12.6486a3.0025,3.0025,0,0,1-2.9951-2.77L8.03,28.1742a2.0012,2.0012,0,0,1,1.9968-2.1535H54.0146A2.0014,2.0014,0,0,1,56.0115,28.1742Zm-1.9908-8.1534v3a1,1,0,0,1-1,1h-42a1,1,0,0,1-1-1v-9a2,2,0,0,1,2-2h11.343a4,4,0,0,1,2.8286,1.1717l3.6567,3.6569a4.0007,4.0007,0,0,0,2.8286,1.1715h19.343A2,2,0,0,1,54.0207,20.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol